export default __webpack_public_path__ + "static/media/news2.3a8d3a05.jpg";